import { Calendar, MonitorSmartphone, Star } from 'lucide-react'

import { GuideTask } from '../types'

// Flag to show/hide optional tasks section (Pasos adicionales)
export const SHOW_OPTIONAL_TASKS = false

// Icons matching the sidebar style
const CalendarIcon = <Calendar strokeWidth={1.5} className="w-7 h-7" />

const StarIcon = <Star strokeWidth={1.5} className="w-7 h-7" />

const DevicesIcon = <MonitorSmartphone strokeWidth={1.5} className="w-7 h-7" />

export const GUIDE_TASKS: GuideTask[] = [
	// Required tasks
	{
		id: 'explore-schedules',
		icon: CalendarIcon, // Same as sidebar Schedules
		title: 'guide.tasks.explore_schedules.title',
		description: 'guide.tasks.explore_schedules.description',
		actionLabel: 'guide.tasks.explore_schedules.action',
		navigateTo: '/schedules?showGuide=true',
		isRequired: true,
		completionKey: 'hasExploredSchedules',
	},
	{
		id: 'assign-content',
		icon: DevicesIcon, // Monitor + smartphone representing zones/devices
		title: 'guide.tasks.assign_content.title',
		description: 'guide.tasks.assign_content.description',
		actionLabel: 'guide.tasks.assign_content.action',
		navigateTo: '/zones?tab=group&showGuide=true',
		isRequired: true,
		completionKey: 'hasAssignedSchedule',
	},
	{
		id: 'activate-zone',
		icon: 'geo-alt', // Same as sidebar Zones
		title: 'guide.tasks.activate_zone.title',
		description: 'guide.tasks.activate_zone.description',
		actionLabel: 'guide.tasks.activate_zone.action',
		navigateTo: '/zones?tab=zones&showGuide=true',
		isRequired: true,
		completionKey: 'hasActiveZone',
	},
	{
		id: 'subscribe',
		icon: StarIcon,
		title: 'guide.tasks.subscribe.title',
		description: 'guide.tasks.subscribe.description',
		actionLabel: 'guide.tasks.subscribe.action',
		navigateTo: '/subscribe',
		isRequired: true,
		completionKey: 'hasSubscription',
	},
	// Optional tasks
	{
		id: 'create-advert',
		icon: 'megaphone', // Same as sidebar Campaigns
		title: 'guide.tasks.create_advert.title',
		description: 'guide.tasks.create_advert.description',
		actionLabel: 'guide.tasks.create_advert.action',
		navigateTo: '/campaigns?showGuide=true',
		isRequired: false,
		completionKey: 'hasCreatedAdvert',
	},
	{
		id: 'invite-users',
		icon: 'people', // Same as Account/Users
		title: 'guide.tasks.invite_users.title',
		description: 'guide.tasks.invite_users.description',
		actionLabel: 'guide.tasks.invite_users.action',
		navigateTo: '/account?tab=users',
		isRequired: false,
		completionKey: 'hasInvitedUsers',
	},
	{
		id: 'create-zones',
		icon: 'geo-alt', // Same as sidebar Zones
		title: 'guide.tasks.create_zones.title',
		description: 'guide.tasks.create_zones.description',
		actionLabel: 'guide.tasks.create_zones.action',
		navigateTo: '/zones/create',
		isRequired: false,
		completionKey: 'hasMultipleZones',
	},
	{
		id: 'create-schedule',
		icon: CalendarIcon, // Same as sidebar Schedules
		title: 'guide.tasks.create_schedule.title',
		description: 'guide.tasks.create_schedule.description',
		actionLabel: 'guide.tasks.create_schedule.action',
		navigateTo: '/schedules?showGuide=true',
		isRequired: false,
		completionKey: 'hasCreatedSchedule',
	},
]

export const getRequiredTasks = () =>
	GUIDE_TASKS.filter((task) => task.isRequired)
export const getOptionalTasks = () =>
	GUIDE_TASKS.filter((task) => !task.isRequired)
